var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5771 9.87397L15.9169 12.5484L19.0633 14.5588L19.6106 9.89084L19.0633 5.32812L15.8566 7.09428L13.5771 9.87397Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1245V18.1023C0 19.0105 0.73725 19.748 1.64569 19.748H5.6235L6.44719 16.7424L5.6235 14.1245L2.89444 13.3008L9.375e-05 14.1245H0Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6235 0L0 5.6235L2.89462 6.44522L5.6235 5.6235L6.43219 3.04116L5.6235 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1258H5.62341V5.62305H0V14.1258Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6556 2.38012L19.0632 5.32724V14.5579L22.6705 17.5164C23.2105 17.9394 24.0004 17.5539 24.0004 16.8675V3.01593C24.0004 2.3219 23.1916 1.93828 22.6555 2.38021",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5771 9.87402V14.1245H5.62354V19.748H17.4177C18.3261 19.748 19.0633 19.0105 19.0633 18.1023V14.5589L13.5771 9.87402Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4177 0H5.62354V5.6235H13.5771V9.87394L19.0633 5.328V1.64578C19.0633 0.737344 18.3261 9.375e-05 17.4177 9.375e-05",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.7812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeet);
export default __webpack_public_path__ + "static/media/gmeet.e383ce521732bf6121b95721cad4dc9f.svg";
export { ForwardRef as ReactComponent };